export default class WyshScore
{
  constructor() {
    this.resultLiteral = "";
    this.resultNormalized = 0;
    this.created = Date.now(); // timestamp.
  }
}
